import { render } from "./ViewProductPriceResult.vue?vue&type=template&id=169e85bb&scoped=true"
import script from "./ViewProductPriceResult.vue?vue&type=script&lang=js"
export * from "./ViewProductPriceResult.vue?vue&type=script&lang=js"

import "./ViewProductPriceResult.vue?vue&type=style&index=0&id=169e85bb&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169e85bb"]])

export default __exports__